import { IOrdersRowData } from '../../interfaces/orders';
import { orderActionTypes } from './order-action-types';
import { IOrderAction, IOrderContextState } from './order-interfaces';
import { ILink } from '../../interfaces/links';

export const ordersReducer = (state: IOrderContextState, action: IOrderAction): IOrderContextState => {
	switch (action.type) {
		case orderActionTypes.SET_DASHBOARD_LOADING: {
			return { ...state, isDashboardDataLoading: action.payload };
		}
		case orderActionTypes.SET_ORDER_ACTIVITY_LOG_LISTS_LOADING: {
			return { ...state, isOrderActivityLogListsLoading: action.payload };
		}
		case orderActionTypes.FETCH_ORDER_ACTIVITY_LOG_LISTS: {
			return { ...state, orderActivityLogLists: action.payload, isOrderActivityLogListsLoading: false };
		}
		case orderActionTypes.SET_ORDER_ACTIVITY_LOG_DATA_LOADING: {
			return { ...state, isOrderActivityLogDataLoading: action.payload };
		}
		case orderActionTypes.FETCH_ORDER_ACTIVITY_LOG_DATA: {
			return {
				...state,
				orderActivityLogData: action.payload?.data,
				enableArchiveSearch: action.payload?.enableArchiveSearch,
				isOrderActivityLogDataLoading: false
			};
		}
		case orderActionTypes.START_REPORT_LIST_LOADING: {
			return { ...state, isReportListLoading: true };
		}
		case orderActionTypes.FETCH_REPORT_TYPES_LIST: {
			return {
				...state,
				reportTypesList: action.payload,
				isReportListLoading: false,
			};
		}
		case orderActionTypes.START_LOADING: {
			return { ...state, isSendingReport: true };
		}
		case orderActionTypes.END_LOADING: {
			return { ...state, isSendingReport: false };
		}
		case orderActionTypes.SET_ORDER_LIST_DATA_LOADING: {
			return { ...state, isOrderDataLoading: action.payload };
		}
		case orderActionTypes.FETCH_ORDER_TABLE_DATA: {
			return {
				...state,
				orderData: action.payload as IOrdersRowData[],
				orderLinks: action.links as ILink[],
				orderTotalItemCount: action.totalItemCount,
				isOrderDataLoading: false,
				isSendingReport: false
			};
		}
		case orderActionTypes.FETCH_ORDER_STATUSES: {
			return {
				...state,
				orderStatuses: action.payload,
				isOrderStatusesLoading: false,
			};
		}
		case orderActionTypes.SET_ORDER_TABLE_DATA_DEFAULT: {
			return {
				...state,
				orderData: null,
				isOrderDataLoading: true,
				isOrderStatusesLoading: true,
				orderLinks: [],
				pageNumber: 0,
				pageSize: 10
			};
		}
		case orderActionTypes.FETCH_DASHBOARD_DATA: {
			return {
				...state,
				dashboardData: action.payload,
				isDashboardDataLoading: false
			};
		}
		case orderActionTypes.SET_ORDER_DETAILS_DATA_LOADING: {
			return { ...state, isOrderDetailsDataLoading: action.payload };
		}
		case orderActionTypes.FETCH_ORDER_DETAILS_DATA: {
			return {
				...state,
				orderDetailsData: action.payload,
				isOrderDetailsDataLoading: false
			};
		}
		case orderActionTypes.SET_ACTIVITY_LOG_LIST_LOADING: {
			return { ...state, isActivityLogListLoading: true };
		}
		case orderActionTypes.FETCH_ACTIVITY_LOG_LISTS: {
			return {
				...state,
				activityLogList: action.payload,
				activityLogTotalItemCount: action.totalItemCount,
				isActivityLogListLoading: false
			};
		}
		case orderActionTypes.START_REFUND_ITEMS_LOADING: {
			return { ...state, isRefundItemsLoading: true };
		}
		case orderActionTypes.END_REFUND_ITEMS_LOADING: {
			return { ...state, isRefundItemsLoading: false };
		}
		case orderActionTypes.SET_DASHBOARD_CASH_DATA: {
			return {
				...state,
				reportCache: action.payload,
			};
		}
		case orderActionTypes.START_CANCEL_ORDER_LOADING: {
			return { ...state, isCancelOrderLoading: true };
		}
		case orderActionTypes.END_CANCEL_ORDER_LOADING: {
			return { ...state, isCancelOrderLoading: false };
		}
		case orderActionTypes.START_EXPORT_CSV_LOADING: {
			return { ...state, isExportCSVLoading: true };
		}
		case orderActionTypes.END_EXPORT_CSV_LOADING: {
			return { ...state, isExportCSVLoading: false };
		}
		case orderActionTypes.SET_ORDER_TABLE_SORTING: {
			return { ...state, orderSorting: action.payload };
		}
		case orderActionTypes.SET_ORDER_TABLE_PAGINATION: {
			return {
				...state,
				pageNumber: action.payload.pageNumber,
				pageSize: action.payload.pageSize
			};
		}
		// case orderActionTypes.SET_PAYOUT_DETAILS_TABLE_PAGINATION: {
		// 	return {
		// 		...state,
		// 		payoutDetailsTablePageNumber: action.payload.pageNumber,
		// 		payoutDetailsTablePageSize: action.payload.pageSize
		// 	};
		// }
		case orderActionTypes.SET_ACTIVITY_LOG_TABLE_PAGINATION: {
			return {
				...state,
				activityLogTablePageNumber: action.payload.pageNumber,
				activityLogTablePageSize: action.payload.pageSize
			};
		}
		case orderActionTypes.SET_ORDER_STATUSES_LOADING: {
			return { ...state, isOrderStatusesLoading: action.payload };
		}
		case orderActionTypes.SET_PARTNERS_COMMISSIONS_LOADING: {
			return { ...state, isPartnersCommissionsLoading: action.payload };
		}
		case orderActionTypes.FETCH_PARTNERS_COMMISSIONS: {
			return {
				...state,
				partnersCommissions: action.payload,
				isPartnersCommissionsLoading: false,
			};
		}
		case orderActionTypes.SET_PARTNERS_COMMISSIONS_BY_ID_LOADING: {
			return { ...state, isPartnersCommissionsByIdLoading: action.payload };
		}
		case orderActionTypes.FETCH_PARTNERS_COMMISSIONS_BY_ID: {
			return {
				...state,
				partnersCommissionsById: action.payload,
				isPartnersCommissionsByIdLoading: false,
			};
		}
		case orderActionTypes.SET_PARTNERS_COMMISSIONS_DETAILS_LOADING: {
			return { ...state, isPartnersCommissionsDetailsLoading: action.payload };
		}
		case orderActionTypes.FETCH_PARTNERS_COMMISSIONS_DETAILS: {
			return {
				...state,
				partnersCommissionsDetails: action.payload,
				isPartnersCommissionsDetailsLoading: false,
			};
		}
		case orderActionTypes.SET_AGENCIES_COMMISSIONS_LOADING: {
			return { ...state, isAgenciesCommissionsLoading: action.payload };
		}
		case orderActionTypes.FETCH_AGENCIES_COMMISSIONS: {
			return {
				...state,
				agenciesCommissions: action.payload,
				isAgenciesCommissionsLoading: false,
			};
		}
		case orderActionTypes.SET_AGENCIES_COMMISSIONS_BY_ID_LOADING: {
			return { ...state, isAgenciesCommissionsByIdLoading: action.payload };
		}
		case orderActionTypes.FETCH_AGENCIES_COMMISSIONS_BY_ID: {
			return {
				...state,
				agenciesCommissionsById: action.payload,
				isAgenciesCommissionsByIdLoading: false,
			};
		}
		case orderActionTypes.SET_AGENCIES_COMMISSIONS_DETAILS_LOADING: {
			return { ...state, isAgenciesCommissionsDetailsLoading: action.payload };
		}
		case orderActionTypes.FETCH_AGENCIES_COMMISSIONS_DETAILS: {
			return {
				...state,
				agenciesCommissionsDetails: action.payload,
				isAgenciesCommissionsDetailsLoading: false,
			};
		}
		case orderActionTypes.SET_FUNDS_RESERVE_LIST_LOADING: {
			return { ...state, isFundsReserveListLoading: action.payload };
		}
		case orderActionTypes.FETCH_FUNDS_RESERVE_LIST: {
			return {
				...state,
				fundsReserveList: action.payload,
				fundsReserveListTotalItemCount: action.totalItemCount,
				isFundsReserveListLoading: false
			};
		}
		case orderActionTypes.SET_FUNDS_RESERVE_LIST_TO_DEFAULT: {
			return {
				...state,
				fundsReserveList: [],
				isFundsReserveListLoading: true,
				// fundsReserveListTotalItemCount: 0,
			};
		}
		case orderActionTypes.SET_FUNDS_RESERVE_LIST_PAGINATION: {
			return {
				...state,
				fundsReserveListTablePageNumber: action.payload.pageNumber,
				fundsReserveListTablePageSize: action.payload.pageSize
			};
		}
		case orderActionTypes.SET_FUNDS_RESERVE_LIST_DETAILS_LOADING: {
			return { ...state, isFundsReserveListDetailsLoading: action.payload };
		}
		case orderActionTypes.FETCH_FUNDS_RESERVE_DETAILS_LIST: {
			return {
				...state,
				fundsReserveListDetails: action.payload,
				isFundsReserveListDetailsLoading: false,
				fundsReserveListDetailsTotalItemCount: action.totalItemCount,
			};
		}
		case orderActionTypes.SET_FUNDS_RESERVE_DETAILS_LIST_PAGINATION: {
			return {
				...state,
				fundsReserveListDetailsTablePageSize: action.payload.pageSize,
				fundsReserveListDetailsTablePageNumber: action.payload.pageNumber
			};
		}
		case orderActionTypes.SET_ORDER_FAVORITE_FILTERS: {
			return { ...state, orderFavoriteFilters: action.payload };
		}

		case orderActionTypes.SET_ORDER_FILTER_STATE: {
			return { ...state, ...action.payload };
		}

		case orderActionTypes.SET_ORDER_RETAILS_DATA_TO_DEFAULT: {
			return {
				...state,
				orderDetailsData: null,
				isOrderDetailsDataLoading: true,
			};
		}

		case orderActionTypes.FETCH_ACTIVITY_LISTS_FAIL: {
			// toaster.push(toastMessage({
			// 	text: 'Update fail',
			// 	type: 'error'
			// }), { placement: 'topEnd' });
			return {
				...state,
				isSendingReport: false,
				isOrderDataLoading: false,
				isDashboardDataLoading: false,
				isActivityLogListLoading: false,
				// isPayoutDetailsDataLoading: false,
				isRefundItemsLoading: false,
				isCancelOrderLoading: false,
				isExportCSVLoading: false,
			};
		}
		default: {
			// toaster.push(toastMessage({
			// 	text: 'Update fail',
			// 	type: 'error'
			// }), { placement: 'topEnd' });
			return state;
		}
	}
};
